import { useMemo } from 'react';
import {
  formatEmissions as formatEmissionsRaw,
  formatChartValue as formatChartValueRaw,
} from '../utils/emissionsFormat';

/**
 * useEmissionsFormatter — ENH-02 binder.
 *
 * Returns formatters closed over the FY total (summary.total_emissions in kg).
 * Components consume the 1-arg signature : `formatEmissions(value)`, no need
 * to thread the total at each call site.
 *
 * If `summary` is null/undefined (loading, FY not selected, etc.), the
 * formatters fall back to the legacy per-value behaviour (cf.
 * `utils/emissionsFormat.js`), which keeps components rendering correctly
 * during the transition (LOT A/B migration).
 *
 * Usage at top of a page :
 *   const { formatEmissions, formatChartValue } = useEmissionsFormatter(summary);
 *   ...
 *   <KPICards formatEmissions={formatEmissions} ... />
 */
export const useEmissionsFormatter = (summary) => {
  const total = summary?.total_emissions;
  return useMemo(() => ({
    formatEmissions: (value) => formatEmissionsRaw(value, total),
    formatChartValue: (value) => formatChartValueRaw(value, total),
  }), [total]);
};

export default useEmissionsFormatter;
